import { useState, useRef, useEffect, useContext, useCallback } from 'react';
import { Spin } from 'antd';

import Down from 'assets/svg/Down';
import { calculateFontSize, getConfig } from 'utils/helperMethods';
import useFetchGetPromptsList from 'hooks/promoRecommendation/UseFetchGetPromptsListData';
import { useOnClickOutside } from 'hooks/general/useOnOutsideClick';
import { promoRecommendation } from 'contexts/PromoRecommendationContext';
import _ from 'lodash';
import { FilterContextData } from 'contexts/FilterContext';
import { trackEventMixpanel } from 'utils/mixpanel';
import { PROMO_RECOMMENDATION_ADD_EVENT_PRODUCT_SELECT_DROPDOWN_CHANGED } from 'utils/mixpanelEventNames';
import { UserContext } from 'contexts/ConfigContext';

interface Props {}

export const LowerLevelList: React.FC<Props> = ({}) => {
    const [listFlag, setList] = useState(false);
    const refForOnlyInternalshowList = useRef(false);
    const outsideClickRef = useRef<any>(null);
    const { loading, error, data, fetchPromptList } = useFetchGetPromptsList();
    const { idForRestOfComponent, allCheckedAttribute } = useContext(FilterContextData);
    const { appConfig: config } = useContext(UserContext);
    const { promoRecommendation: promoRecommendationConfig } = config;
    const retailerKey = promoRecommendationConfig.retailerKey;
    const { addLeverData, setAddLeverData, editMode, selectedPlan, editRowData } = useContext(promoRecommendation);

    useEffect(() => {
        const updatedEventData = addLeverData?.promotionMechanic
            ? { promotionMechanic: addLeverData?.promotionMechanic }
            : editMode
            ? { promotionMechanic: editRowData?.promotionMechanic }
            : {};
        fetchPromptList({
            variables: {
                dim2AttributeName: `${Object.keys(allCheckedAttribute[retailerKey])?.[0]}`,
                filters: JSON.stringify(idForRestOfComponent),
                selectedField: 'dim1_id',
                eventData: JSON.stringify(updatedEventData),
                isEdit: editMode,
                planId: 1, //hardcoded no use for backend
            },
        });
    }, [idForRestOfComponent, addLeverData?.promotionMechanic, editMode]);

    //show list function
    const showList = () => {
        setList(!listFlag);
        refForOnlyInternalshowList.current = !refForOnlyInternalshowList.current;
    };

    //call apply filter

    //close expanded filter on clicking outside
    const clickOutsideHandler = useCallback(
        (event: any) => {
            if (listFlag) {
                setList(false);
            }
        },
        [listFlag],
    );
    useOnClickOutside(outsideClickRef, clickOutsideHandler);

    //onclick of dropdown
    let onClickOfDropdown = (listFlag: any) => {
        if (listFlag) {
        }
        showList();
    };

    //onclick of checkbox of attribute name
    const onClickCheckbox = (checkboxItem: any, e: any) => {
        if (e.target.checked) {
            setAddLeverData((oldData: any) => {
                let data = _.cloneDeep(oldData);

                data['SelectedLowerLevel'][checkboxItem.promptName] = {
                    ...checkboxItem,
                    openStock: 0,
                    shipperStock: 100,
                };
                return data;
            });
        } else {
            setAddLeverData((oldData: any) => {
                let data = _.cloneDeep(oldData);
                delete data['SelectedLowerLevel'][checkboxItem.promptName];
                return data;
            });
        }
    };

    const ScaledHeight = calculateFontSize(window.innerHeight, 200);
    //onchange of search value
    return (
        <div className="inline-block relative cursor-pointer w-full" ref={outsideClickRef}>
            <div
                className="dropdown-height !w-full rounded border border-purpleFont border-0 dropdown-width flex items-center justify-between px-2"
                onClick={() => onClickOfDropdown(listFlag)}
            >
                <span className="font-xxs !text-fontGray">Select Product's</span>
                <span className="z-10 font-normal  text-center text-slate-300 text-base w-8 mr-[-7px]">
                    <Down />
                </span>
            </div>
            <div
                className={`bg-white dropdown-menu absolute z-50 text-primary w-full shadow-l drop-shadow-lg rounded-b overflow-auto ${
                    listFlag ? `` : `hidden`
                }`}
                style={{ height: ScaledHeight }}
            >
                {loading ? (
                    <div className="flex justify-center items-center" style={{ height: ScaledHeight }}>
                        <Spin />
                    </div>
                ) : (
                    <ul style={{ height: ScaledHeight }}>
                        {!data?.length ? (
                            <div className="flex justify-center items-center h-full w-full mt-6">No PPG present</div>
                        ) : (
                            ''
                        )}
                        {data?.map((item: any, index: number) => {
                            return (
                                <li key={item.promptName} className={'mx-3 mt-2'}>
                                    <label className="font-sm flex gap-2 items-center cursor-pointer" key={index}>
                                        <div className="min-w-4 min-h-4">
                                            <input
                                                type={'checkbox'}
                                                className={'checkbox-size accent-purpleFont'}
                                                checked={
                                                    item.promptName in addLeverData['SelectedLowerLevel'] ? true : false
                                                }
                                                onChange={(e) => {
                                                    onClickCheckbox(item, e);
                                                    trackEventMixpanel(
                                                        PROMO_RECOMMENDATION_ADD_EVENT_PRODUCT_SELECT_DROPDOWN_CHANGED,
                                                        {
                                                            dropdownName: item?.label,
                                                            isChecked: e.target.checked,
                                                        },
                                                    );
                                                }}
                                                value={addLeverData['SelectedLowerLevel'][item.promptName]}
                                            />
                                        </div>
                                        <span style={{ wordBreak: 'break-all' }} className="font-xs !font-normal">
                                            {item?.promptName}
                                        </span>
                                    </label>
                                </li>
                            );
                        })}
                    </ul>
                )}
            </div>
        </div>
    );
};
